<template>
  <div class="overflow-y-auto rounded-lg shadow">
    <table class="w-full">
      <orders-list-table-head-component />
      <orders-list-table-body-component
        :resultFormat="resultFormat"
        :orders="orders"
        :section="section"
        @open-details="openDetails"
      />
    </table>
    <template v-if="detailsSymbols">
      <ontick-modal-component :open="modalIsActive" @close="modalIsActive = false">
        <details-modal-component
          :modalIsLoading="modalIsLoading"
          :modalData="modalData"
          :detailsSymbols="detailsSymbols"
        />
      </ontick-modal-component>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ontickModalComponent from "../../../../shared/components/basic/ontick-modal.component.vue";
import DetailsModalComponent from "./details-modal.component.vue";
import OrdersListTableBodyComponent from "./orders-list-table-body.component.vue";
import ordersListTableHeadComponent from "./orders-list-table-head.component.vue";
export default {
  components: {
    ordersListTableHeadComponent,
    OrdersListTableBodyComponent,
    ontickModalComponent,
    DetailsModalComponent,
  },

  props: {
    orders: {
      type: Array,
    },
    section: {
      type: String,
    },
    resultFormat: {
      type: String,
    },
  },

  data() {
    return {
      modalIsActive: false,
      modalIsLoading: false,
      modalData: {
        name: "asdasda",
      },
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
    detailsSymbols() {
      return this.orders.find((item) => item.alg_ord_id === this.modalData.alg_ord_id);
    },
  },

  methods: {
    openDetails(id) {
      const account_id = this.getSelectedAccount.account_id;
      this.modalIsActive = true;
      this.modalIsLoading = true;
      this.$api
        .get(this.$endpoint.GET_ALGO_ORDER_DETAILS, {
          params: {
            alg_ord_id: id,
            account_id: this.section !== "PRIVATE" ? undefined : account_id,
          },
        })
        .then((res) => {
          // console.log(res.data);
          this.modalData = { ...res.data, ald_ord_id: id };
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
          this.modalIsActive = false;
        })
        .finally(() => {
          this.modalIsLoading = false;
        });
    },
  },
};
</script>
